import { ReactComponent as ArrowDownSmallIcon } from '../../../assets/icons/arrow-down-dark.svg';
import { ReactComponent as ArrowDownSmallIconDisabled } from '../../../assets/icons/arrow-down-gray.svg';
import { ReactComponent as ArrowLeftLargeIcon } from '../../../assets/icons/arrow-left-dark.svg';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit-dark.svg';
import { ReactComponent as DragIcon } from '../../../assets/icons/new-drag.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-outlined.svg';
import { ReactComponent as DuplicateIcon } from '../../../assets/icons/content_copy.svg';
import { ReactComponent as DeleteFillIcon } from '../../../assets/icons/delete-new-icon.svg';
import { ReactComponent as DeleteFillIconDisabled } from '../../../assets/icons/delete-new-icon-gray.svg';
import { ReactComponent as CopyIcon } from '../../../assets/icons/copy.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/icons/remove.svg';
import { ReactComponent as RemoveIconDisabled } from '../../../assets/icons/remove-gray.svg';
import { ReactComponent as ReportIcon } from '../../../assets/icons/bar_chart_dark.svg';
import { ReactComponent as ReportIconDisabled } from '../../../assets/icons/bar_chart_gray.svg';
import { ReactComponent as AttributeReportIcon } from '../../../assets/icons/insert_drive_file.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-icon-new.svg';
import { ReactComponent as DotsIcon } from '../../../assets/icons/more_horiz.svg';
import { ReactComponent as ClearIcon } from '../../../assets/icons/close-red-background.svg';
import { ReactComponent as PreviewIcon } from '../../../assets/icons/remove_red_eye.svg';
import { ReactComponent as PreviewHideIcon } from '../../../assets/icons/eye-icon-hide.svg';
import { ReactComponent as ResolveIcon } from '../../../assets/icons/playlist_add_check.svg';
import { ReactComponent as RescheduleIcon } from '../../../assets/icons/more_time.svg';
import { ReactComponent as AcceptIcon } from '../../../assets/icons/check.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download-icon.svg';
import { ReactComponent as ReloadIcon } from '../../../assets/icons/refresh-dark.svg';
import { ReactComponent as PeopleIcon } from '../../../assets/icons/people-dark.svg';
import { ReactComponent as ComparePeopleDarkIcon } from '../../../assets/icons/compare-dark.svg';
import { ReactComponent as SyncIcon } from '../../../assets/icons/sync.svg';
import { ReactComponent as SendIcon } from '../../../assets/icons/send.svg';
import { ReactComponent as SendIconDisabled } from '../../../assets/icons/send-gray.svg';
import { ReactComponent as StopIcon } from '../../../assets/icons/stop.svg';
import { ReactComponent as ReportCreateIcon } from '../../../assets/icons/topic-icon.svg';
import { ReactComponent as ReportCreateIconDisabled } from '../../../assets/icons/topic-icon-gray.svg';
import { ReactComponent as LoupeIcon } from '../../../assets/icons/loupe.svg';
import { ReactComponent as LiveHelpIcon } from '../../../assets/icons/live_help.svg';
import { ReactComponent as UserInviteIcon } from '../../../assets/icons/invite_user.svg';
import { ReactComponent as UserReinviteIcon } from '../../../assets/icons/reinvite_user.svg';
import { ReactComponent as UserDeactivateIcon } from '../../../assets/icons/person_off.svg';
import { ReactComponent as UserRevokeAccessIcon } from '../../../assets/icons/revoke_user_access.svg';
import { ReactComponent as UserReactivateIcon } from '../../../assets/icons/person_add.svg';
import { ReactComponent as NotificationIcon } from '../../../assets/icons/notification-gray.svg';
import { ReactComponent as MarkAsReadIcon } from '../../../assets/icons/mark_email_read.svg';
import { ReactComponent as SendEnvelopeIcon } from '../../../assets/icons/send-envelope.svg';
import { ReactComponent as AddIcon } from '../../../assets/icons/plus-icon.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/add_invitation.svg';
import { ReactComponent as LinkIcon } from '../../../assets/icons/insert_link.svg';
import { ReactComponent as LinkIconDisabled } from '../../../assets/icons/insert_link_gray.svg';
import { ReactComponent as AddCommentIcon } from '../../../assets/icons/add_comment_small.svg';
import { ReactComponent as EditCommentIcon } from '../../../assets/icons/mark_email_unread_small.svg';
import { ReactComponent as CommentIcon } from '../../../assets/icons/comment_dark.svg';
import { ReactComponent as ArchiveIcon } from '../../../assets/icons/archive.svg';
import { ReactComponent as DisqualifyIcon } from '../../../assets/icons/not_interested_light.svg';
import { ReactComponent as QualifyIcon } from '../../../assets/icons/refresh.svg';
import { ReactComponent as CookieIcon } from '../../../assets/icons/cookie.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/upload-small.svg';
import { ReactComponent as VoteAgainstIcon } from '../../../assets/icons/thumb_down_alt.svg';
import { ReactComponent as VoteForIcon } from '../../../assets/icons/thumb_up_alt.svg';
import { ReactComponent as ExposureNegIcon } from '../../../assets/icons/exposure_neg_1.svg';
import { ReactComponent as ExposurePlusIcon } from '../../../assets/icons/exposure_plus_1.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info_light.svg';
import { ReactComponent as VerticalAlignRight } from '../../../assets/icons/vertical_align_right.svg';
import { primaryPalette } from '../../../styles/theme';

export const ACTION_BUTTON_TYPES = {
  ADD: 'ADD',
  ADD_COMMENT: 'ADD_COMMENT',
  ATTRIBUTE_REPORT: 'ATTRIBUTE_REPORT',
  ACCEPT: 'ACCEPT',
  ARROW: 'ARROW',
  ARROW_LEFT: 'ARROW_LEFT',
  CALENDAR: 'CALENDAR',
  CLOSE: 'CLOSE',
  CLEAR: 'CLEAR',
  COPY: 'COPY',
  COOKIE: 'COOKIE',
  COMMENT: 'COMMENT',
  DELETE: 'DELETE',
  DUPLICATE: 'DUPLICATE',
  DELETE_FILL: 'DELETE_FILL',
  DRAG: 'DRAG',
  DOTS: 'DOTS',
  DOWNLOAD: 'DOWNLOAD',
  EXPAND: 'EXPAND',
  EDIT: 'EDIT',
  EDIT_COMMENT: 'EDIT_COMMENT',
  MINUS_ONE: 'MINUS_ONE',
  NOTIFICATION: 'NOTIFICATION',
  MARK_AS_READ: 'MARK_AS_READ',
  INFO: 'INFO',
  LINK: 'LINK',
  REMOVE: 'REMOVE',
  REPORT: 'REPORT',
  REPORT_CREATE: 'REPORT_CREATE',
  PEOPLE_COMPARE: 'PEOPLE_COMPARE',
  PREVIEW: 'PREVIEW',
  PREVIEW_HIDE: 'PREVIEW_HIDE',
  PREVIEW_DESCRIPTION: 'PREVIEW_DESCRIPTION',
  PREVIEW_QUESTIONS: 'PREVIEW_QUESTIONS',
  PLUS_ONE: 'PLUS_ONE',
  RELOAD: 'RELOAD',
  RESOLVE: 'RESOLVE',
  RESCHEDULE: 'RESCHEDULE',
  SYNC: 'SYNC',
  PEOPLE: 'PEOPLE',
  SEND: 'SEND',
  SEND_ENVELOPE: 'SEND_ENVELOPE',
  STOP: 'STOP',
  USER_REACTIVATE: 'USER_REACTIVATE',
  USER_INVITE: 'USER_INVITE',
  USER_REINVITE: 'USER_REINVITE',
  USER_REVOKE_ACCESS: 'USER_REVOKE_ACCESS',
  USER_DEACTIVATE: 'USER_DEACTIVATE',
  UNARCHIVE: 'UNARCHIVE',
  UPLOAD: 'UPLOAD',
  DISQUALIFY: 'DISQUALIFY',
  QUALIFY: 'QUALIFY',
  VOTE_FOR: 'VOTE_FOR',
  VOTE_AGAINST: 'VOTE_AGAINST',
};

export const BUTTON_ICONS = {
  [ACTION_BUTTON_TYPES.ACCEPT]: {
    icon: AcceptIcon,
  },
  [ACTION_BUTTON_TYPES.ADD]: {
    icon: AddIcon,
    borderColor: primaryPalette.bluish1,
  },
  [ACTION_BUTTON_TYPES.ADD_COMMENT]: {
    borderColor: primaryPalette.bluish1,
    icon: AddCommentIcon,
  },
  [ACTION_BUTTON_TYPES.ARROW]: {
    icon: ArrowDownSmallIcon,
    iconDisabled: ArrowDownSmallIconDisabled,
  },
  [ACTION_BUTTON_TYPES.ARROW_LEFT]: {
    icon: ArrowLeftLargeIcon,
    borderColor: primaryPalette.bluish6,
  },
  [ACTION_BUTTON_TYPES.CALENDAR]: {
    icon: CalendarIcon,
  },
  [ACTION_BUTTON_TYPES.CLOSE]: {
    icon: CloseIcon,
  },
  [ACTION_BUTTON_TYPES.CLEAR]: {
    icon: ClearIcon,
  },
  [ACTION_BUTTON_TYPES.COPY]: {
    icon: CopyIcon,
  },
  [ACTION_BUTTON_TYPES.COOKIE]: {
    icon: CookieIcon,
  },
  [ACTION_BUTTON_TYPES.COMMENT]: {
    icon: CommentIcon,
  },
  [ACTION_BUTTON_TYPES.DELETE]: {
    icon: DeleteIcon,
  },
  [ACTION_BUTTON_TYPES.DUPLICATE]: {
    icon: DuplicateIcon,
  },
  [ACTION_BUTTON_TYPES.DELETE_FILL]: {
    icon: DeleteFillIcon,
    iconDisabled: DeleteFillIconDisabled,
  },
  [ACTION_BUTTON_TYPES.DRAG]: {
    icon: DragIcon,
  },
  [ACTION_BUTTON_TYPES.DOTS]: {
    icon: DotsIcon,
  },
  [ACTION_BUTTON_TYPES.EDIT]: {
    icon: EditIcon,
  },
  [ACTION_BUTTON_TYPES.EDIT_COMMENT]: {
    borderColor: primaryPalette.bluish1,
    icon: EditCommentIcon,
  },
  [ACTION_BUTTON_TYPES.PLUS_ONE]: {
    icon: ExposurePlusIcon,
  },
  [ACTION_BUTTON_TYPES.MINUS_ONE]: {
    icon: ExposureNegIcon,
  },
  [ACTION_BUTTON_TYPES.EXPAND]: {
    icon: VerticalAlignRight,
  },
  [ACTION_BUTTON_TYPES.LINK]: {
    icon: LinkIcon,
    iconDisabled: LinkIconDisabled,
  },
  [ACTION_BUTTON_TYPES.INFO]: {
    icon: InfoIcon,
  },
  [ACTION_BUTTON_TYPES.NOTIFICATION]: {
    icon: NotificationIcon,
  },
  [ACTION_BUTTON_TYPES.MARK_AS_READ]: {
    icon: MarkAsReadIcon,
  },
  [ACTION_BUTTON_TYPES.PEOPLE]: {
    borderColor: primaryPalette.bluish1,
    icon: PeopleIcon,
  },
  [ACTION_BUTTON_TYPES.PEOPLE_COMPARE]: {
    borderColor: primaryPalette.bluish1,
    icon: ComparePeopleDarkIcon,
  },
  [ACTION_BUTTON_TYPES.REMOVE]: {
    icon: RemoveIcon,
    iconDisabled: RemoveIconDisabled,
  },
  [ACTION_BUTTON_TYPES.RESOLVE]: {
    icon: ResolveIcon,
    borderColor: primaryPalette.bluish1,
  },
  [ACTION_BUTTON_TYPES.RESCHEDULE]: {
    icon: RescheduleIcon,
  },
  [ACTION_BUTTON_TYPES.REPORT]: {
    icon: ReportIcon,
    iconDisabled: ReportIconDisabled,
  },
  [ACTION_BUTTON_TYPES.ATTRIBUTE_REPORT]: {
    icon: AttributeReportIcon,
  },
  [ACTION_BUTTON_TYPES.REPORT_CREATE]: {
    icon: ReportCreateIcon,
    iconDisabled: ReportCreateIconDisabled,
  },
  [ACTION_BUTTON_TYPES.PREVIEW_DESCRIPTION]: {
    icon: LoupeIcon,
  },
  [ACTION_BUTTON_TYPES.PREVIEW_QUESTIONS]: {
    icon: LiveHelpIcon,
  },
  [ACTION_BUTTON_TYPES.PREVIEW]: {
    icon: PreviewIcon,
  },
  [ACTION_BUTTON_TYPES.PREVIEW_HIDE]: {
    icon: PreviewHideIcon,
  },
  [ACTION_BUTTON_TYPES.DOWNLOAD]: {
    icon: DownloadIcon,
  },
  [ACTION_BUTTON_TYPES.RELOAD]: {
    icon: ReloadIcon,
  },
  [ACTION_BUTTON_TYPES.SYNC]: {
    borderColor: primaryPalette.bluish1,
    icon: SyncIcon,
  },
  [ACTION_BUTTON_TYPES.SEND]: {
    icon: SendIcon,
    iconDisabled: SendIconDisabled,
    borderColor: primaryPalette.bluish1,
    borderDisabledColor: primaryPalette.bluish5,
  },
  [ACTION_BUTTON_TYPES.SEND_ENVELOPE]: {
    icon: SendEnvelopeIcon,
  },
  [ACTION_BUTTON_TYPES.STOP]: {
    icon: StopIcon,
    borderColor: primaryPalette.bluish1,
  },
  [ACTION_BUTTON_TYPES.USER_REVOKE_ACCESS]: {
    borderColor: primaryPalette.bluish1,
    icon: UserRevokeAccessIcon,
  },
  [ACTION_BUTTON_TYPES.USER_INVITE]: {
    borderColor: primaryPalette.bluish1,
    icon: UserInviteIcon,
  },
  [ACTION_BUTTON_TYPES.USER_REINVITE]: {
    borderColor: primaryPalette.bluish1,
    icon: UserReinviteIcon,
  },
  [ACTION_BUTTON_TYPES.USER_DEACTIVATE]: {
    borderColor: primaryPalette.bluish1,
    icon: UserDeactivateIcon,
  },
  [ACTION_BUTTON_TYPES.USER_REACTIVATE]: {
    borderColor: primaryPalette.bluish1,
    icon: UserReactivateIcon,
  },
  [ACTION_BUTTON_TYPES.UNARCHIVE]: {
    icon: ArchiveIcon,
  },
  [ACTION_BUTTON_TYPES.UPLOAD]: {
    icon: UploadIcon,
  },
  [ACTION_BUTTON_TYPES.DISQUALIFY]: {
    icon: DisqualifyIcon,
  },
  [ACTION_BUTTON_TYPES.QUALIFY]: {
    icon: QualifyIcon,
  },
  [ACTION_BUTTON_TYPES.VOTE_FOR]: {
    icon: VoteForIcon,
  },
  [ACTION_BUTTON_TYPES.VOTE_AGAINST]: {
    icon: VoteAgainstIcon,
  },
};
